// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Migration_MigrarFranquiaInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract de POST /migration/franquias/migrar
 * (controllers/migration/franquias.php::migrar).
 *
 * Um unico campo, obrigatorio: qual unidade ATIVA do Zoho migrar.
 *
 * ---------------------------------------------------------------------------
 * POR QUE `strictJsonTypes()` E TRUE AQUI — nao e preferencia de estilo
 * ---------------------------------------------------------------------------
 * O ID do Creator tem 19 digitos e e MAIOR que 2^53 (medido: armadilha A1 da
 * skill zoho-data-migration). Um cliente que mandasse `{"zoho_id": 45420...07}`
 * como NUMERO JSON ja teria perdido digitos no `JSON.stringify` do navegador —
 * o valor que chega aqui e outro ID, nao o pedido.
 *
 * Sem `strictJsonTypes()`, o `fill()` coagiria esse numero para string em
 * silencio e a migracao seguiria com o id errado: no melhor caso
 * UNIDADE_NAO_ENCONTRADA, no pior um ledger apontando para a unidade errada.
 * Com ele, um `zoho_id` que nao seja string e RECUSADO na validacao — o erro
 * aparece na borda, que e o unico lugar onde ainda da para consertar.
 */
import { registerContract } from './validate'

export interface Migration_MigrarFranquiaInput {
zoho_id: string
}

registerContract('Migration_MigrarFranquiaInput', {
  zoho_id: { type: 'string',  required: true },
})
